<template>
  <div class="network-page">
    <app-page-header title="Unidades">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus"></b-icon>NOVO
      </button>
    </app-page-header>

    <network-table></network-table>
  </div>
</template>

<script>
import NetworkTable from '@/components/Tables/UnitsTable.vue';

export default {
  name: 'unitsu-page',
  components: {
    NetworkTable,
  },
  methods: {
    create() {
      this.$router.push('/units/create');
    },
  },
};
</script>

<style lang="scss" scoped></style>
